const PET_HEIGHT_PX = 52;
// Matches the lane column's gap-3.
const GAP_PX = 12;

export const racetrackLanes = {
  PET_HEIGHT_PX,
  GAP_PX,
};
